/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { LftSidePaneActionId } from '../shared';

export const LftSidePaneCompareFilesAction = (onClickHandler?: () => void): Action => ({
    id: LftSidePaneActionId.CompareFiles,
    checked: false,
    primaryContent: strings.getString('lftSidePaneCompareFilesTitle'),
    secondaryContent: strings.getString('lftSidePaneCompareFilesContent'),
    onClick: () => {
        onClickHandler?.(); 
    }
});
